export default "/images/vendor/flag-icons/flags/4x3/vn.svg?e80173a9c3cbaa60c5937fb87b9dcb3f";